import React from 'react';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';

import CBTRedirection from '@stubhub/react-cbt-redirection';

const EventTitle = ({name, webURI, isRedirectModalEnabled, entityType, venueCountry, onClick, onTitleClick}) => (
  <div className="EventItem__Title" style={{wordWrap: 'break-words'}} onClick={onTitleClick}>
    <CBTRedirection
      className="EventItem__TitleLink"
      isEnabled={isRedirectModalEnabled}
      location={entityType || 'event'}
      countryCode={venueCountry}
      uri={webURI}
      onClick={onClick}
      mode="optional"
    >
      <Dotdotdot clamp={2}>{name}</Dotdotdot>
    </CBTRedirection>
  </div>
);

EventTitle.propTypes = {
  // The name of the event
  name: PropTypes.string.isRequired,

  // The web URI for the event
  webURI: PropTypes.string,

  // If true, enables the redirect modal
  isRedirectModalEnabled: PropTypes.bool,

  // The type of entity (e.g., event, venue)
  entityType: PropTypes.string,

  // The country of the venue
  venueCountry: PropTypes.string,

  // Function to handle click events
  onClick: PropTypes.func,

  // Function to handle title click events
  onTitleClick: PropTypes.func,
};

export default EventTitle;
